export default __webpack_public_path__ + "static/media/light-logo.da0e27a2.svg";